import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import SearchPageVariation from './SearchPageVariation';
import { parseAmenityFromPath, getFilterParamForAmenity } from 'lib/search/parseAmenityFromPath';

const SearchPageSwitcher = (props) => {
	return <SearchPageVariation {...props} />;
};

const enhance = compose(
	connect((state, props) => {
		// Parse query params from the location (if present)
		const params = props.location
			? new URLSearchParams(props.location.search)
			: new URLSearchParams('');
		const queryParams = props.location ? Object.fromEntries(params) : {};

		// Inject the amenity filter param so checkboxes reflect the active filter.
		// The amenity slug may come from the pathname (clean URL like
		// /Chicago-IL-self-storage/drive-up-storage-units.html) or from the
		// query string (?amenity=drive-up-storage-units). When the user unchecks
		// the filter, the amenity param is also cleared (see handleAmenityToggle),
		// so this won't re-inject after an explicit uncheck.
		const amenitySlug = parseAmenityFromPath(props.location?.pathname) || queryParams.amenity;
		if (amenitySlug) {
			const filterParam = getFilterParamForAmenity(amenitySlug);
			if (filterParam && !queryParams[filterParam]) {
				queryParams[filterParam] = 'true';
			}
			// Ensure amenity is in queryParams so that filter handlers can clear it
			// when the user unchecks the corresponding filter. Without this,
			// handleSearchParamChange spreads searchParams (from Redux) which
			// re-introduces amenity into the URL.
			if (!queryParams.amenity) {
				queryParams.amenity = amenitySlug;
			}
		}

		const urlQueryParams = props.location ? Object.fromEntries(params) : {};

		return {
			queryParams,
			urlQueryParams,
		};
	})
);

export default enhance(SearchPageSwitcher);
